export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS";
export const GET_ALL_PRODUCTS_RESPONSE_SUCCESS =
    "GET_ALL_PRODUCTS_RESPONSE_SUCCESS";
